import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollTop from './components/ScrollTop';
import Preloader from './components/Preloader';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetails from './pages/ServiceDetails';
import Portfolio from './pages/Portfolio';
import PortfolioDetails from './pages/PortfolioDetails';
import Team from './pages/Team';
import Contact from './pages/Contact';

// Initialize AOS and other libraries
import AOS from 'aos';
import 'aos/dist/aos.css';
import { initLibraries } from './utils/initLibraries';

function App() {
  useEffect(() => {
    // Initialize AOS with enhanced settings
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      mirror: false,
      offset: 100,
      delay: 0,
      anchorPlacement: 'top-bottom'
    });

    // Initialize other libraries after a short delay to ensure DOM is ready
    // PureCounter is loaded via script tag in index.html
    setTimeout(() => {
      initLibraries();
    }, 300);
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Preloader />
          <Header />
          <main className="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:id" element={<ServiceDetails />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:id" element={<PortfolioDetails />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <ScrollTop />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
